export type TemporaryContactIdentityPayload = {
  fromMe?: boolean | null;
  senderName?: string | null;
};

/**
 * Resolve somente a identidade temporária exibida na lista de contatos.
 * Em mensagens de saída, senderName identifica o autor da mensagem, não o contato.
 */
export const resolveTemporaryContactName = (
  payload: TemporaryContactIdentityPayload,
  phone: string,
): string => {
  if (payload.fromMe === true) {
    return phone;
  }

  return payload.senderName || phone;
};
